import Alert from "@cloudscape-design/components/alert";
import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import ExpandableSection from "@cloudscape-design/components/expandable-section";
import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  /** "page" thay toàn bộ nội dung trang, "section" chỉ thay phần bị hỏng. */
  level?: "page" | "section";
}

interface State {
  error: Error | null;
}

/**
 * Cloudscape yêu cầu thông báo lỗi kỹ thuật nằm trong expandable section để
 * người dùng gửi lại được cho hỗ trợ, chứ không phải làm thông điệp chính.
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("Giao diện gặp lỗi ngoài dự kiến", error, info.componentStack);
  }

  override render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <Box margin={this.props.level === "page" ? { top: "l" } : undefined}>
        <Alert
          type="error"
          statusIconAriaLabel="Lỗi"
          header="Không hiển thị được nội dung"
          action={<Button onClick={() => window.location.reload()}>Tải lại trang</Button>}
        >
          <Box variant="p">
            Phần này gặp lỗi ngoài dự kiến. Tải lại trang để thử lại. Nếu lỗi lặp lại, gửi nội dung sau cho hỗ trợ
            FaceGo.
          </Box>
          <ExpandableSection headerText="Chi tiết kỹ thuật">
            <Box variant="code">{error.message}</Box>
          </ExpandableSection>
        </Alert>
      </Box>
    );
  }
}
